import { render } from "./templates/index.html?vue&type=template&id=f8c32a1a&external"
import script from "./script?vue&type=script&lang=js&external"
export * from "./script?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__